/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


interface FormData {
  event: string,
  interface : string,
  role : string,
  employee: string,
  fromDate: string,
  toDate: string,
}

const listAuditReport = async (formData: FormData, page:number , size:number, sort : any , order:any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/audit_log/list?page=${page}&size=${size}&order=${order}&sort=${sort}&keyword=` , {
        params: {
          action: formData.event || '',
          interface_type: formData.interface || '',
          user_id: formData.employee || '',
          to_date_time : formData.toDate||'',
          from_date_time: formData.fromDate|| '',  
          role_id:formData.role || ''       
        },
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}


interface UserFormData {
  role : string,
  employee: string,
  fromDate: string,
  toDate: string,
}

const listUserAccessReport = async (formData: UserFormData, page:number , size:number, sort : any , order:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/logs/list_user_access_logs?page=${page}&size=${size}&order=${order}&sort=${sort}&keyword=` , {
      params: {
        user_id: formData.employee || '',
        to_date_time : formData.toDate||'',
        from_date_time: formData.fromDate|| '',         
      },
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}


const auditTrialReport = {
    listAuditReport,
    listUserAccessReport
};
  
  
export { auditTrialReport };